 

import {Link} from 'react-router-dom'
import {KTIcon} from '../../../helpers'

const HelpDrawer = () => {
  return (
    <div></div>
  ) 
}

export {HelpDrawer}
